module.exports = __webpack_public_path__ + "img/yhgl@2x.997fd162.png";